import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import { appState3dsAtom } from '@onramp/state/recoil/atoms/appState3dsAtom';
import { useAtomValue } from 'jotai';
import { v4 as uuidv4 } from 'uuid';

type RiskSessionManagerContextValue = {
  sessionKey: string;
};

export const RiskSessionManagerContext = createContext<RiskSessionManagerContextValue>({
  sessionKey: '',
});

export function RiskSessionManagerProvider({ children }: { children: ReactNode }) {
  const restoredSessionKey = useAtomValue(appState3dsAtom)?.riskifiedSessionKey;
  const [sessionKey] = useState(() => restoredSessionKey ?? uuidv4());
  const value = useMemo(() => ({ sessionKey }), [sessionKey]);

  return (
    <RiskSessionManagerContext.Provider value={value}>
      {children}
    </RiskSessionManagerContext.Provider>
  );
}

export function useRiskSessionManager() {
  return useContext(RiskSessionManagerContext);
}
